import { useFieldMatchingStore } from '../store/field-matching.store';
import { useOperationsCount } from '../query/use-operations-count.query';

export const useMisalignmentsCount = () => {
  const { orgId } = useFieldMatchingStore();

  const { count } = useOperationsCount({ orgId });

  return count ?? 0;
};
